import Features from './Features'
import Highlights from './Highlights'
import Journey from './Journey'
import Team from './Team'
import Traffic from './Traffic'
import Users from './Users'

/** The order is the order the questions get asked. */
const Sections = () => (
  <div className="grid gap-8">
    <Highlights />
    <Users />
    <Traffic />
    <Journey />
    <Features />
    <Team />
  </div>
)

export default Sections
